import React from "react";

const footer = () => {
    return (
        <div className="Footer">
            <a href="https://github.com/NikolaPerisic" target="blank">
                @NP
            </a>
        </div>
    );
};
export default footer;
